<template>
  <div class="field-selector">
    <div v-show="value.length > 0" class="count-box">
      <span class="color-Gray_75">选择了{{ value.length }}个字段</span>
      <span class="btn-change pLeft16 pointer" style="color: #2196f3;" @click="showSelectField">
        <i class="el-icon-edit"></i>
        修改字段
      </span>
    </div>
    <div v-if="value.length == 0" class="add-btn" :class="{ 'is-enabled': sheetId }">
      <div v-if="sheetId" @click="showSelectField">+ 选择填写字段</div>
      <div v-else>请先选择工作表</div>
    </div>
    <el-tree
      v-show="treeData.length"
      :data="treeData"
      :props="{ children: 'subList', label: 'name' }"
      :allow-drop="allowDrop"
      :allow-drag="allowDrag"
      :expand-on-click-node="false"
    >
      <div class="row" slot-scope="{ node, data }">
        <span v-tip class="label">{{ node.label }}</span>
        <el-checkbox
          :value="data.type === 'H'"
          @input="data.type = $event ? 'H' : 'W'"
          @change="emitValue(treeData)"
        >
          必填
        </el-checkbox>
        <el-button icon="el-icon-delete-solid" type="text" @click="removeField(data)"></el-button>
      </div>
    </el-tree>
    <select-fields
      ref="selectFields"
      :key="sheetId"
      :exclude-readonly-control="excludeReadonlyControl"
      @submit="updateSheetFieldSelected"
    ></select-fields>
  </div>
</template>
<script>
import SelectFields from "@/views/Company/Manage/Project/TaskTemplate/EditDialog/SelectFields"
import { getAllDefaultControls } from "@/api/sheet/sheet"
import { transFieldControl } from "@/utils/sheet"
import { bfs } from "@/utils/algorithm"
export default {
  name: "field-selector",
  components: { SelectFields },
  props: {
    value: {
      type: Array,
      default: () => []
    },
    sheetId: String, // 当前sheet
    sheetMap: Object,
    excludeReadonlyControl: Boolean
  },
  computed: {
    treeData() {
      return this.fillData(this._.cloneDeep(this.value))
    },
    controlMap() {
      return this._.chain(this.sheetMap)
        .values()
        .map("controls")
        .flatten()
        .map(c => transFieldControl(c))
        .keyBy("_cid")
        .value()
    }
  },
  data() {
    return {
      controlTypeMap: {}
    }
  },
  created() {
    getAllDefaultControls().then(res => (this.controlTypeMap = this._.keyBy(res, "_type")))
  },
  methods: {
    showSelectField() {
      let currentSheetFieldSelected = []
      bfs({
        arr: this.value || [],
        childFuc: row => row.subList,
        cbk: row => {
          let { cid, _parent } = row
          let curCid = (_parent ? _parent._prefix : "") + cid
          currentSheetFieldSelected.push(curCid)
          row._prefix = curCid + "_"
        }
      })
      this.$refs.selectFields.open(this.sheetId, currentSheetFieldSelected)
    },
    updateSheetFieldSelected(cids) {
      let rowStateMap = {}
      bfs({
        arr: this.value || [],
        childFuc: row => row.subList,
        cbk: row => {
          let { cid, _parent } = row
          let curCid = (_parent ? _parent._prefix : "") + cid
          row._prefix = curCid + "_"
          rowStateMap[curCid] = row.type
        }
      })
      let rowMap = {}
      cids
        .sort((a, b) => a.length - b.length)
        .forEach(cidStr => {
          let index = cidStr.lastIndexOf("_")
          if (index < 0) {
            rowMap[cidStr] = { cid: cidStr, type: rowStateMap[cidStr] || "W", subList: [] }
            return
          }
          let cid = cidStr.slice(index + 1)
          let prefix = cidStr.slice(0, index)
          let row = {
            cid: cid,
            type: rowStateMap[cidStr] || "W",
            subList: []
          }
          rowMap[cidStr] = row
          rowMap[prefix].subList.push(row)
        })
      this.emitValue(
        Object.keys(rowMap)
          .filter(cid => cid.length == 24)
          .map(cid => rowMap[cid])
      )
    },
    fillData(rows, namePrefix = "") {
      rows.forEach(row => {
        const control = this.controlMap[row.cid]
        if (!control) return
        const typeName = this.controlTypeMap?.[control._type]?.name
        row.name = `[${control.isField ? "_" : ""}${typeName}] ${namePrefix}${control.name}`
        if (row.subList?.length) {
          this.fillData(row.subList, `${namePrefix}${control.name}.`)
        }
      })
      return rows
    },
    allowDrop(draggingNode, dropNode, type) {
      return dropNode.level === 1 && ["next", "prev"].includes(type) // 允许第一级拖拽排序
    },
    allowDrag(draggingNode) {
      return draggingNode.level === 1 // 允许第一级拖拽排序
    },
    filterRecursive(rows, row) {
      return rows.filter(r => {
        if (r.cid === row.cid) return false
        if (r.subList?.length) {
          r.subList = this.filterRecursive(r.subList, row)
        }
        return true
      })
    },
    removeField(row) {
      this.emitValue(this.filterRecursive(this.value, row))
    },
    emitValue(value) {
      this.$emit("input", value)
    }
  }
}
</script>
<style scoped lang="scss">
.field-selector {
  ::v-deep {
    .el-tree-node {
      &:focus .el-tree-node__content {
        background-color: unset;
      }
      .el-tree-node__content {
        height: 35px;
        margin-bottom: 10px;
        &:hover {
          background-color: unset;
        }
      }
    }
  }
  .el-tree {
    position: relative;
    left: -24px;
    width: 434px;
  }
  .add-btn {
    height: 36px;
    line-height: 36px;
    background: #f8f8f8;
    border-radius: 4px;
    padding: 0 17px;
    box-sizing: border-box;
    color: #c0c4cc;
    &.is-enabled {
      color: #2196f3;
      cursor: pointer;
      &:hover {
        background: #f5f5f5;
      }
    }
  }
  .row {
    display: flex;
    align-items: center;
    flex: 1;
    overflow: hidden;
    .label {
      flex: 1;
      background: #f8f8f8;
      border-radius: 10px;
      padding: 0 15px;
    }
    .el-checkbox {
      width: 60px;
      margin-left: 10px;
      padding: 0 10px;
      background: #f8f8f8;
      border-radius: 10px;
    }
    .el-button {
      width: 30px;
      margin-left: 10px;
    }
  }
}
</style>
